<script setup lang="ts">
defineProps<{ percent: number; period: string }>()
</script>

<template>
  <div class="grow rounded bg-primary-100 px-4 py-2">
    <I18nT
      class="m-0 sm:text-left"
      keypath="search.favoritePeriods.text"
      tag="p"
    >
      <template #percent>{{ percent }}</template>
      <template #period>
        <strong>
          {{ $t(`search.favoritePeriods.${period}`) }}
        </strong>
      </template>
    </I18nT>
  </div>
</template>
